<template>
  <div class="verifying-individual">
    <p>名字</p>
    <input class="text_form" type="text" v-model="firstName"/>

    <p>名前</p>
    <input class="text_form" type="text" v-model="lastName"/>

    <p>名字（カナ）</p>
    <input class="text_form" type="text" v-model="individual.first_name_kana"/>

    <p>名前（カナ）</p>
    <input class="text_form" type="text" v-model="individual.last_name_kana"/>

    <p>戸籍上の性別</p>
    <input class="radio_form" type="radio" v-model="individual.gender" value="male" id="male">
    <label class="radio-label_form" for="male">男性</label>
    <input class="radio_form" type="radio" v-model="individual.gender" value="female" id="female">
    <label class="radio-label_form" for="female">女性</label>

    <p>メールアドレス</p>
    <input class="text_form" type="email" v-model="individual.email"/>

    <p>生年月日</p>
    <DatetimeFormBox
      v-model="dob"
      :is-visible-year="true"
      :is-visible-month="true"
      :is-visible-date="true"
    />

    <AddressInputForm v-model="individual.address_kanji" :kana="false" @setTempPostalCode="setTempPostalCode"/>
    <AddressInputForm v-model="individual.address_kana" :kana="true"/>
  </div>
</template>

<script>
  import DatetimeFormBox from "@/components/molecules/box/form/DatetimeFormBox";
  import {mapGetters} from "vuex";
  import moment from "moment";
  import AddressInputForm from "@/components/objects/stripe/account/AddressInputForm";

  export default {
    name: "VerifyingIndividual",

    components: {AddressInputForm, DatetimeFormBox},

    props: {
      individual: {
        type: Object,
        required: true
      },
    },

    data() {
      return {
        dob: null,
        firstName: '',
        lastName: '',
      }
    },

    watch: {
      firstName: {
        handler: function () {
          this.individual.first_name = this.firstName;
          this.individual.first_name_kanji = this.firstName;
        }
      },
      lastName: {
        handler: function () {
          this.individual.last_name = this.lastName;
          this.individual.last_name_kanji = this.lastName;
        }
      },
      dob: {
        handler: function () {
          this.individual.dob.year = moment(this.dob).year();
          this.individual.dob.month = moment(this.dob).month() + 1;
          this.individual.dob.day = moment(this.dob).date();
        }
      },
    },

    computed: {
      ...mapGetters({user: 'auth/user'}),
    },

    created() {
      this.individual.email = this.user.email
    },

    methods: {
      setTempPostalCode(postalCode){
        this.$emit('setTempPostalCode', postalCode)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .verifying-individual {
    .text_form, label {
      width: 100%;
    }
  }
</style>